class AppController {
    constructor(
        $window,
        BootstrapSettings,
        CurrentUser,
        appConfig
    ){
        'ngInject';
        this.$window = $window;
        this.BootstrapSettings = BootstrapSettings;
        this.CurrentUser = CurrentUser;
        this.appConfig = appConfig;
    }

    $onInit() {
        angular.element(document).ready(() => {
            this.BootstrapSettings.initializeSettings()
        });
    }

    /***
     * Determine whether we should show the page header (only shows if the current user is of "User" status.
     */
    showHeader() {
        return this.CurrentUser.isLoggedIn();
    }

}

export default AppController;


// WEBPACK FOOTER //
// ./app/app-controller.js